import { render, staticRenderFns } from "./EmailRankingChart.vue?vue&type=template&id=56ccd2f8&"
import script from "./EmailRankingChart.vue?vue&type=script&lang=js&"
export * from "./EmailRankingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports